import React, { useContext, useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import { Container, CourseCard, SearchBar } from '../../components';
import { Main } from '../../components/Main';
import { CourseContext, UserContext } from '../../components/provider';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import notification from '../../utils/notifications';
import { getNumberOfPage, getCourseRender} from '../../utils/utils';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { COURSES_URL } from '../../config/urls';
import SuggestCourseDialog from '../../components/SuggestCourseDialog';

const {REACT_APP_BASE_BACKEND_URL, REACT_APP_NUMBER_COURSE_PER_PAGE} = process.env;
const  GET_COURSES_API_URL = REACT_APP_BASE_BACKEND_URL + '/api/view-course';

const CourseView = () =>{
  const theme= useTheme();
  const {
    courses,
    setCourses,
  } = useContext(CourseContext);
  const navigate = useNavigate();
  const {user} = useContext(UserContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [numberOfPage, setNumberOfPage]= useState(1);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [courseRender, setCourseRender] =useState([]);

  const handlePagination = (event, value)=>{
    setSearchParams(`?p=${value}`);
  };

  useEffect(()=>{
		document.title = 'Course Pool | All Tutorials';
    getCourses();

  },[])

  const getCourses = () => {
    setIsLoading(true)
    const token = window.localStorage.getItem('jwt');

    fetch(GET_COURSES_API_URL,{
      method: 'GET',
      credentials: 'include',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `${token && `jwt ${token}`}`
      }
    }).then(res => res.json())
      .then(data => {
        let temp = [];
        setNumberOfPage(4);
				for (let i = 0; i < data.length; i++){
					temp.push(data[i]);
				}
				setCourses(temp);
        setIsLoading(false);
      }).catch(e =>{
        setIsLoading(false);
        notification('Cannot get data from server');

      })
  }

  useEffect(()=>{ 
    if(courses.length) {
      setNumberOfPage(getNumberOfPage(courses.length));
      setCurrentPageNumber(1);
    };
    setCourseRender(courses.slice(0, REACT_APP_NUMBER_COURSE_PER_PAGE));
  },[courses]);

  useEffect(()=>{ 
    const page = searchParams.get('p');

    if(page){
      const pageIndex = parseInt(searchParams.get('p'));
      if(pageIndex <= numberOfPage && pageIndex > 0){
        setCurrentPageNumber(pageIndex);
        setCourseRender(getCourseRender(courses, pageIndex - 1));
      }
      else navigate(COURSES_URL)
    }
    else {
      setNumberOfPage(getNumberOfPage(courses.length));
      setCourseRender(getCourseRender(courses, 0));
      setCurrentPageNumber(1);
    }
  },[searchParams]);

  
  return(
    <Main>
      <Container 
        maxWidth={'100%'}
        sx={{
          backgroundColor: theme.palette.alternate.main,
          paddingTop: 13,
          width: '100%',
        }}
      >
        <Box>
          <Typography
            variant={'h4'}
            gutterBottom
            align={'center'}
            sx={{ fontWeight: 700 }}
          >
              Time to practice and learn
          </Typography>
          <Typography
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            variant={'h6'}
            component={'p'}
            color={'text.secondary'}
            align={'center'}
            maxWidth={"50%"}
            marginX={'auto'}
          >
              This page contains all well-hand-picked tutorials.
              </Typography>
          <Typography display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            variant={'h6'}
            component={'p'}
            color={'text.secondary'}
            align={'center'}
            maxWidth={"50%"}
            marginX={'auto'}>
          We will keep updating the list.
          </Typography> 
        </Box>
      </Container>

      <Box
        component={'svg'}
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1920 100.1"
        sx={{
          marginBottom: -1,
          width: 1,
          marginTop: -4,
        }}
      >
        <path fill={theme.palette.background.paper}
          d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"/>
      </Box>

      <Container 
        marginTop={{xs: -2,sm:-10, md:-11}}
        marginBottom={-4}
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Box width={'80%'} 
        maxWidth={'1000px'}>
          <SearchBar/>
        </Box>

      </Container>
      
      {isLoading && 
          <Container 
          marginTop={{xs: -2,sm:-10, md:-11}}
          marginBottom={-4}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <CircularProgress/>

        </Container>
      }

      {courses.length > 0 &&
      <Container 
        display={'flex'}
        justifyContent={'flex-end'}
        alignItems={'center'}
        paddingY={ {xs: 4,sm: 0}}
      >  
        <Stack spacing={2}>
          <Pagination 
            count={courses.length === 0 ? 1 : numberOfPage} 
            variant="outlined" 
            color='secondary' 
            onChange={handlePagination} 
            disabled={(courses.length === 0)}
            page={currentPageNumber}

          />
        </Stack>
      </Container>
      }

      <Container>
        <CourseCard courses={courseRender} authenticated={user?.email ? true : false}/>
      </Container>

      <Box 
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        paddingY={{ xs: 4, sm: 6, md: 8 }}
      >
        <Stack spacing={2}>
          <Pagination 
            count={courses.length === 0 ? 1 : numberOfPage} 
            page={currentPageNumber}
            disabled={(courses.length === 0)}
            variant="outlined" color="secondary" onChange={handlePagination} />
        </Stack>
      </Box>
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        paddingBottom={{ xs: 4, sm: 6, md: 8 }}
      >
        <SuggestCourseDialog/>
      </Box>
      </Main>
  )
};

export default CourseView;